import { render, staticRenderFns } from "./QcentrisCountryTurnover.vue?vue&type=template&id=1f7cbdfd&scoped=true&"
import script from "./QcentrisCountryTurnover.vue?vue&type=script&lang=js&"
export * from "./QcentrisCountryTurnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7cbdfd",
  null
  
)

export default component.exports